import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";

const TermToggle = ({ termType = "months", setTermType }) => {
  // Use useCallback to prevent unnecessary re-renders
  const handleMonthsChange = useCallback(
    () => setTermType("months"),
    [setTermType]
  );
  const handleWeeksChange = useCallback(
    () => setTermType("weeks"),
    [setTermType]
  );
  return (
    <div className="mrc-term-toggle">
      <div className="toggle-container">
        <label className={termType === "months" ? "active" : ""}>
          <span className="radio-circle">
            {termType === "months" && <span className="radio-dot"></span>}
          </span>
          <input
            type="radio"
            name="mrc-term-type"
            value="months"
            checked={termType === "months"}
            onChange={handleMonthsChange}
          />
          <span className="label-text">Months</span>
        </label>
        <label className={termType === "weeks" ? "active" : ""}>
          <span className="radio-circle">
            {termType === "weeks" && <span className="radio-dot"></span>}
          </span>
          <input
            type="radio"
            name="mrc-term-type"
            value="weeks"
            checked={termType === "weeks"}
            onChange={handleWeeksChange}
          />
          <span className="label-text">Weeks</span>
        </label>
      </div>
    </div>
  );
};

// Add PropTypes for type checking
TermToggle.propTypes = {
  termType: PropTypes.oneOf(["months", "weeks"]),
  setTermType: PropTypes.func.isRequired,
};

// Use memo to prevent unnecessary re-renders
export default memo(TermToggle);
